<!-- Template -->

<template>
    <div>
        <Header />

        <TopNavigation :path="path" />

        <section id="main-container">
            <div class="login-form">
                <ValidationObserver ref="validation" v-slot="{ invalid }">
                    <form>
                        <div class="title">
                            <h3>Reset Password</h3>
                        </div>

                        <!-- Notifications -->

                        <FormNotification :message="notification" />
                        <FormNotification is-error :message="error" />

                        <!-- New Password -->
                        <div class="form-group">
                            <ValidationProvider
                                name="password"
                                vid="newPassword"
                                rules="required|min:8|verify_password"
                                v-slot="{ errors }"
                                v-if="!isChanged"
                            >
                                <div
                                    class="input-wrap d-flex flex-column"
                                    :class="{'is-error': errors.length }"
                                >
                                    <label>New password</label>
                                    <input
                                        autofocus
                                        type="password"
                                        v-model="newPassword"
                                        class="form-control"
                                    />
                                    <span class="error-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <!-- Password Confirmation -->
                        <div class="form-group mt-4">
                            <ValidationProvider
                                name="password"
                                vid="confirmPassword"
                                rules="required|min:8|confirmed:newPassword"
                                v-slot="{ errors }"
                                v-if="!isChanged"
                            >
                                <div
                                    class="input-wrap d-flex flex-column"
                                    :class="{'is-error': errors.length }"
                                >
                                    <label>Confirm password</label>
                                    <input
                                        type="password"
                                        v-model="confirmPassword"
                                        class="form-control"
                                    />
                                    <span class="error-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <!-- Buttons -->
                        <div class="submit" v-if="!isChanged">
                            <button
                                type="submit"
                                class="btn-large btn-blue btn-block"
                                :disabled="invalid || isProcessing"
                                @click.prevent="onSubmit"
                            >
                                <span v-if="!isProcessing">Reset</span>
                                <span v-if="isProcessing" class="spinner-border"></span>
                            </button>
                        </div>

                        <div>
                            <a @click="$router.push('Login')">Back to login</a>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </section>
        <Footer />
    </div>
</template>

<!-- Script -->

<script>
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    import TopNavigation from "@/components/TopNavigation";
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import { PageMessage } from "@/models/page-message";
    import { AccountService } from "@/services/account-service";
    import FormNotification from "@/components/Login/FormNotification";

    export default {
        name: "ResetPassword",

        components: {
            Header,
            Footer,
            TopNavigation,
            ValidationProvider,
            ValidationObserver,
            FormNotification
        },

        data() {
            return {
                newPassword: "",
                confirmPassword: "",
                isChanged: false,
                isProcessing: false,
                error: new PageMessage(),
                notification: new PageMessage(),
                path: []
            };
        },

        computed: {
            validator() {
                return this.$refs.validation;
            }
        },

        created() {
            this.accountService = new AccountService(this.$api, this.$store);
        },

        methods: {
            async onSubmit() {
                const isValid = await this.validator.validate();
                if (!isValid) return;

                this.isProcessing = true;
                this.error.reset();
                this.notification.reset();

                try {
                    var response = await this.accountService.resetPassword(
                        this.newPassword,
                        this.confirmPassword,
                        localStorage.getItem("resetToken")
                    );
                    this.isChanged = true;
                    this.notification.set(response + '.');
                    localStorage.removeItem("resetToken");
                } catch (error) {
                    if (error.details.data.NewPassword) {
                        if(error.details.data.NewPassword[0] == 'You can\'t use last 3 passwords'){
                            this.error.setError('You must not use any of your last 3 passwords.');
                        }else{
                            this.error.setError(error.details.data.NewPassword[0]);
                        } 
                    } else if (error.details.data == "Reset Password failed.") {
                        this.error.setError("Your token has expired.");
                    } else {
                        this.error.setError(error.details.data);
                    }
                } finally {
                    this.isProcessing = false;
                }
            }
        }
    };
</script>

<!-- Style -->

<style scoped lang="scss" src="@/styles/pages/_login.scss" />